module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_5_10.d8d8ed09.png";